export default __webpack_public_path__ + "static/media/2278.747c870b.png";